import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeftIcon, IconButton, Tooltip } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useHistoryContext } from "~/routes/context";

export const BackButton = ({ url, title, className, forceUrl }) => {
  const { state, popFromState } = useHistoryContext();
  const backUrl = state && state.length > 1 && !forceUrl ? state[state.length - 2].pathname : url;
  const tooltipTitle = state && state.length > 1 && !forceUrl ? state[state.length - 2].title : title;

  const location = useLocation();
  const queryParam = location?.search?.replace("?", "");

  return (
    <Tooltip
      title={tooltipTitle}
      placement="top"
    >
      <Link
        to={backUrl}
        state={queryParam ? { param: queryParam } : null}
        className={classNames("tw-shrink-0", className)}
        onClick={popFromState}
      >
        <IconButton variant="text gray">
          <ArrowLeftIcon />
        </IconButton>
      </Link>
    </Tooltip>
  );
};

BackButton.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  forceUrl: PropTypes.bool,
};
